/*
  tr-card-swipe.js — les points du défilement de la carte produit.

  Le défilement lui-même est du CSS : scroll-snap sur la piste, aucun
  script. Ce fichier ne fait qu'une chose, allumer le bon point — sans
  lui, rien ne dit combien de visuels attendent ni où l'on en est, et le
  geste ne s'invente pas.

  Un IntersectionObserver par carte, avec la piste pour racine : moins
  cher qu'un écouteur `scroll`, qui se déclencherait des dizaines de fois
  par balayage sur une grille de vingt cartes.

  Le composant n'est chargé que si le mode « défilement » est actif dans
  l'éditeur. Dans l'autre mode, la carte survole comme avant et cette
  ligne n'est jamais servie.
*/

if (!customElements.get('tr-card-swipe')) {
  customElements.define(
    'tr-card-swipe',
    class TrCardSwipe extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-card-track]');
        this.dots = Array.from(this.querySelectorAll('.tr-card__dot'));
        if (!this.track || this.dots.length < 2) return;

        this.slides = Array.from(this.track.children);

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const rang = this.slides.indexOf(entry.target);
              this.dots.forEach((dot, position) => {
                dot.classList.toggle('is-active', rang === position);
              });
            });
          },
          { root: this.track, threshold: 0.6 }
        );

        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
